import type { SVGProps } from 'react'

export default function ArrowUpRight(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.528 5.42194C19.0742 5.47755 19.5003 5.93917 19.5003 6.49999V18.4167H17.3337V9.11522L7.26627 19.1826L5.73438 17.6507L15.8017 7.58332H6.50032V5.41666H18.417L18.528 5.42194Z"
				fill="currentColor"
			/>
		</svg>
	)
}
